import React from 'react';
import { createPortal } from 'react-dom';
import closeIcon from '../assets/img/close.svg';

interface ModalProps {
  show: boolean;
  close: Function | null;
  title: string | null;
  children: React.ReactNode;
}

function Modal({ show, close = null, title = null, children }: ModalProps) {
  if (!show) return null;

  return createPortal(
    <div className="modalContainer">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <header>
          {title && <h2>{title}</h2>}
          {close && (
            <button type="button" className="close" onClick={() => close()}>
              <img src={closeIcon} alt="close" />
            </button>
          )}
        </header>
        <main>{children}</main>
      </div>
    </div>,

    document.getElementById('modal')
  );
}
export default Modal;
